import React, {useState, useRef} from 'react';
import {FormattedMessage} from 'react-intl';
import PackageTitle from '../PackageTitle';
import PackagePrice from '../PackagePrice';
import CheckMark from '../../../icons/checkMark.svg';
import AddMark from '../../../icons/add.svg';

import {Wraper, Content, RadioMark, SingleFeature} from './styles';
const RadioBox = ({
  radioValue,
  setRadioValue,
  subscriptionPlan,
  order,
  currency,
  oldPaymentMethod,
  header,
  subHeader,
  usedPaymentMethod,
  methodName,
  setPaymentInfo,
  paymentInfo,
}) => {
  const {
    planType,
    title,
    titleIcon,
    subtitle,
    price,
    discountedPrice,
    benefits,
  } = subscriptionPlan || {};
  const {cardName, lastFourDigits, name} = usedPaymentMethod || {};

  const radioRef = useRef(null);
  const creditCard =
    cardName === 'VISA'
      ? `فيزا تنتهي ب ${lastFourDigits}`
      : `ماستركارد تنتهي ب ${lastFourDigits}`;
  const debitCard =
    name === 'PAYPAL' ? 'باي بال' : name === 'KNET' ? 'كي نت' : 'فوري';
  subHeader = subHeader ? subHeader : cardName ? creditCard : debitCard;

  return (
    <Wraper
      onClick={() => radioRef.current.click()}
      active={
        oldPaymentMethod ? paymentInfo === methodName : radioValue === planType
      }
      order={oldPaymentMethod ? null : order}
    >
      <input
        type="radio"
        onChange={(e) => {
          if (oldPaymentMethod) {
            setPaymentInfo(methodName);
          } else {
            setRadioValue(e.target.value);
          }
        }}
        value={oldPaymentMethod ? methodName : planType}
        name="subscription"
        ref={radioRef}
      />{' '}
      <Content>
        {!oldPaymentMethod ? (
          <>
            <RadioMark active={radioValue === planType} />
            <PackageTitle
              isMargin={true}
              title={title}
              subtitle={subtitle}
              titleIcon={titleIcon}
            />
            <PackagePrice
              price={price}
              discountedPrice={discountedPrice}
              planType={planType}
              currency={currency}
            />
            <hr />
            {benefits.map((benefit, i) => (
              <SingleFeature key={i} index={i}>
                <img src={i === 2 ? AddMark : CheckMark} alt="list icon" />
                <p>{benefit}</p>
              </SingleFeature>
            ))}
          </>
        ) : (
          <>
            <RadioMark active={paymentInfo === methodName} />
            <h4 className="mb3">{header}</h4>
            <span className="gray">{subHeader}</span>
          </>
        )}
      </Content>
    </Wraper>
  );
};

export default RadioBox;
